import { render } from "./popElgmov.vue?vue&type=template&id=1bff8d37&scoped=true"
import script from "./popElgmov.vue?vue&type=script&lang=js"
export * from "./popElgmov.vue?vue&type=script&lang=js"

import "./popElgmov.vue?vue&type=style&index=0&id=1bff8d37&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/smt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bff8d37"]])

export default __exports__